import {IErrorResponseItem, ValidationError, ValidationErrors} from "../services/validator";
import {CurrenciesAllowed} from "../config/currencies";
import {ITransactionFormOutputData} from "../components/Transactions/Components/Form/config/models";

export enum TransactionValidationField {
    AMOUNT = "Transaction.Amount",
    CURRENCY = "Transaction.Currency",
    PURCHASED_AT = "Transaction.PurchasedAt",
    AMOUNT_DETAILS_TOTAL = "Transaction.Details.AmountDetails",
    FUEL_AMOUNT = "Transaction.Details.Fuel.Amount",
    VEHICLE_FOR_HIRE_DISTANCE_UNIT = "Transaction.Details.VehicleForHire.DistanceUnit",
    VEHICLE_FOR_HIRE_DISTANCE = "Transaction.Details.VehicleForHire.Distance",
    VEHICLE_FOR_HIRE_PICKUP_ADDRESS = "Transaction.Details.VehicleForHire.PickupAddress",
    VEHICLE_FOR_HIRE_PICKUP_TIME = "Transaction.Details.VehicleForHire.PickupTime",
    VEHICLE_FOR_HIRE_DROP_OFF_TIME = "Transaction.Details.VehicleForHire.DropOffTime",
    VEHICLE_FOR_HIRE_DROP_OFF_ADDRESS = "Transaction.Details.VehicleForHire.DropOffAddress",
    SUB_TRANSACTIONS = "Transaction.Details.SubTransactions",
    SUB_TRANSACTION_DATE = "Transaction.Details.SubTransactions.[].Date",
    SUB_TRANSACTION_AMOUNT = "Transaction.Details.SubTransactions.[].Amount",
    SUB_TRANSACTION_DESCRIPTION = "Transaction.Details.SubTransactions.[].Description",
    SPLIT_FRIEND_NAME = "Transaction.Details.Splits.[].Name",
    SPLIT_FRIEND_AMOUNT = "Transaction.Details.Splits.[].Amount",
    ALLOWANCE_ID = "Transaction.Allowances.[].ID",
    ALLOWANCE_AMOUNT = "Transaction.Allowances.[].Amount",
}

export type TransactionValidation = {
    [key in TransactionValidationField]?: ValidationError[];
};

export type TransactionValidationErrors = ValidationErrors<TransactionValidation, TransactionValidationField>;

export const transactionsValidationFactory = (errors: IErrorResponseItem[]): TransactionValidationErrors => {
    const v = new ValidationErrors<TransactionValidation, TransactionValidationField>();
    v.setMap({
        amount: TransactionValidationField.AMOUNT,
        currency: TransactionValidationField.CURRENCY,
        purchasedAt: TransactionValidationField.PURCHASED_AT,
    });
    v.setKeyParser((key) => {
        return key
            .replace('NewTransaction', 'Transaction')
            .replace('UpdateTransaction', 'Transaction');
    });
    v.setErrors(errors)

    return v;
};

export const validateTransactionForm = (data: ITransactionFormOutputData): TransactionValidationErrors => {
    const errors = transactionsValidationFactory([]);

    if (CurrenciesAllowed.indexOf(data.currency) === -1) {
        errors.add(TransactionValidationField.CURRENCY, ValidationError.CURRENCY_NOT_ALLOWED);
    }
    if (!data.amount || isNaN(data.amount)) {
        errors.add(TransactionValidationField.AMOUNT, ValidationError.REQUIRED);
    }
    if (data.purchasedAt === '') {
        errors.add(TransactionValidationField.PURCHASED_AT, ValidationError.REQUIRED);
    }

    return errors;
};
